<template>
    <section class="workflow" aria-labelledby="workflow-title">
        <div class="d-flex align-center flex-wrap mb-2">
            <div>
                <div id="workflow-title" class="subtitle-2 font-weight-bold">Avanzamento della segnalazione</div>
                <div class="caption grey--text text--darken-1">{{ completion }}% pronto per la verifica NC</div>
            </div>
            <v-spacer />
            <v-chip v-if="restored" x-small outlined color="primary" class="mr-2">
                <v-icon x-small left>mdi-history</v-icon>Bozza ripristinata
            </v-chip>
            <v-chip x-small :color="dirty ? 'orange lighten-4' : 'green lighten-4'" class="black--text">
                <v-icon x-small left>{{ dirty ? "mdi-content-save-edit-outline" : "mdi-content-save-check-outline" }}</v-icon>
                {{ dirty ? "Salvataggio…" : "Bozza salvata" }}
            </v-chip>
        </div>
        <v-progress-linear :value="completion" height="7" rounded color="primary" aria-label="Completamento bozza" />
        <div class="workflow__steps mt-3" role="group" aria-label="Requisiti della NC">
            <button
                v-for="item in checklist"
                :key="item.id"
                type="button"
                class="workflow__step"
                :class="{ 'workflow__step--done': item.done }"
                @click="$emit('navigate', item.id)"
            >
                <v-icon small :color="item.done ? 'success' : 'grey'">
                    {{ item.done ? "mdi-check-circle" : "mdi-checkbox-blank-circle-outline" }}
                </v-icon>
                <span>{{ item.label }}</span>
            </button>
        </div>
    </section>
</template>

<script>
import { draftChecklist, draftCompletion } from "./mailSegnalazioniWorkflow.mjs";

export default {
    name: "MailSegnalazioneWorkflow",
    props: {
        draft: { type: Object, required: true },
        dirty: { type: Boolean, default: false },
        restored: { type: Boolean, default: false },
    },
    computed: {
        checklist() { return draftChecklist(this.draft); },
        completion() { return draftCompletion(this.draft); },
    },
};
</script>

<style scoped>
.workflow { padding: 16px 24px; border-bottom: 1px solid rgba(0, 0, 0, 0.08); background: rgba(25, 118, 210, 0.04); }
.workflow__steps { display: flex; flex-wrap: wrap; gap: 8px; }
.workflow__step { display: inline-flex; align-items: center; gap: 6px; min-height: 36px; padding: 6px 10px; border: 1px solid rgba(0, 0, 0, 0.18); border-radius: 4px; background: var(--v-background-base); color: inherit; font: inherit; cursor: pointer; }
.workflow__step--done { border-color: var(--v-success-base); }
.workflow__step:focus-visible { outline: 3px solid var(--v-primary-base); outline-offset: 2px; }
@media (max-width: 599px) { .workflow { padding: 14px 16px; } .workflow__step { width: 100%; } }
</style>
